import Model  from '@/utils/models';

export default class Product extends Model { 
    backend = '/survey/report/';           
    
    demografi(params={}){
        return this.api.get(this.backend+'demografi', params).then(res => {          
            return res.status == 200 ? res.data : [];
        });
    }

    sebaran(params={}){
        return this.api.get(this.backend+'sebaran', params).then(res => {          
            return res.status == 200 ? res.data : [];
        });
    }

    silang(params={}){
        return this.api.get(this.backend+'silang', params).then(res => {          
            return res.status == 200 ? res.data : [];
        });
    }

    silangSebaran(params={}){
        return this.api.get(this.backend+'silang-sebaran', params).then(res => {          
            return res.status == 200 ? res.data : [];
        });
    }

    jilids(params={}){
        return this.api.get('/survey/jilid/index', params).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }

    surveys(params={}){
        return this.api.get(this.backend+'survey', params).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }

    respondens(params={}){
        return this.api.get(this.backend+'responden', params).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }

    node(params={}){
        return this.api.get('/master/node/view', params).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }

    provinsi(params={}){
        params = {...params,...{paging:false}}
        return this.api.get('/master/node/index', params).then(res => {          
            return res.status == 200 ? res.data.data : {};
        });
    }

    kabupaten(params={}){
        params = {...params,...{paging:false}}
        return this.api.get('/master/node/index', params).then(res => {          
            return res.status == 200 ? res.data.data : {};
        });
    }

    dapil(params={}){
        params = {...params,...{paging:false}}
        return this.api.get('/survey/dapil/index', params).then(res => {          
            return res.status == 200 ? res.data.data : {};
        });
    }

    kecamatan(params={}){
        params = {...params,...{paging:false}}
        return this.api.get('/master/node/index', params).then(res => {          
            return res.status == 200 ? res.data.data : {};
        });
    }

    kelurahan(params={}){
        params = {...params,...{paging:false}}
        return this.api.get('/master/node/index', params).then(res => {          
            return res.status == 200 ? res.data.data : {};
        });
    }

    tps(params={}){
        return this.api.get('/survey/tps/index', params).then(res => {          
            return res.status == 200 ? res.data : {};
        });
    }

    users(params={}){
        return this.api.get('rbac/user/index', params).then(res => {
            return res.status == 200 ? res.data : {};
        });
    }

    jilid(params={}){
        return this.api.get('/survey/jilid/view', params).then(res => {          
            return res.status == 200 ? res.data : Survey.query().where((survey) => {
                return survey.id == params.id
            }).first();
        });
    }
}

